/**
 * Source pixels per world metre for every sprite contract (weapon skins,
 * entity sprites, skill assets). An authoring convention for presentation
 * art only: no collision, reach, contact or damage code reads it.
 */
export const ASSET_SOURCE_PIXELS_PER_METRE = 512;
